import React from 'react';
import ShareableLinkMain from './pages/ShareableLinkMain';
import classNames from 'classnames';
import HelmetWrapper from 'components/HelmetWrapper';
import { useTranslation } from 'react-i18next';

import './ShareableLink.router.styles.scss';

const ShareableLink: React.FC = () => {
  const classes = classNames('shareable-link-router');

  const { t } = useTranslation();

  return (
    <div className={classes}>
      <HelmetWrapper title={t('secureShare')} />
      <ShareableLinkMain />
    </div>
  );
};

export default ShareableLink;
